import React from 'react';
import classnames from 'classnames';
import { useTheme } from '../theme';

export type CardVariant = 'default' | 'elevated';
export type CardProps = {
  variant?: CardVariant;
} & React.HTMLAttributes<HTMLDivElement>;

/**
 * This component exposes 4 child components that you can use to build the required markup:
 * `CardHeader`, `CardHeaderTitle`, `CardHeaderSubtitle` and `CardContent`.
 *
 * Example:
 * ```tsx
 * const Example = () => (
 *   <Card>
 *     <CardHeader>
 *        <CardHeaderTitle>Card title</CardHeaderTitle>
 *        <CardHeaderSubtitle>Card details</CardHeaderSubtitle>
 *      </CardHeader>
 *     <CardContent><p>card content text</p></CardContent>
 *   </Card>
 * )
 * ```
 */
export const Card = ({
  className,
  variant = 'default',
  ...props
}: CardProps): React.ReactElement => {
  const theme = useTheme();
  const classNames = classnames(className, 'airtame-card', `airtame-card--variant-${variant}`);
  return <div className={classNames} data-theme={theme} {...props} />;
};

Card.displayName = 'Card';
